import { render } from "./BusinessSidenavs.vue?vue&type=template&id=eca639a2"
import script from "./BusinessSidenavs.vue?vue&type=script&lang=js"
export * from "./BusinessSidenavs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__